import React from "react";
import Card from "../card";
import PhotoCardPhotos from "../photo-card/PhotoCardPhotos";
import { Details, DummyTextBlock, DummyAvatar } from "./styled/photo-card-loading";
function PhotoCardLoading() {
    return (React.createElement(Card, null,
        React.createElement(Card.Header, null,
            React.createElement(PhotoCardPhotos, { photos: ["", "", ""] })),
        React.createElement(Card.Body, null,
            React.createElement(Details, null,
                React.createElement(DummyTextBlock, null),
                React.createElement(DummyTextBlock, null),
                React.createElement(DummyTextBlock, null))),
        React.createElement(Card.Footer, null,
            React.createElement(DummyAvatar, null))));
}
export default PhotoCardLoading;
